import React from 'react';
import { MapPin, Clock, Phone, Instagram } from 'lucide-react';
import { CONTACT_ADDRESS, CONTACT_HOURS, WA_MAIN, getTelLink, trackPhoneClick, toDisplay, INSTAGRAM_URL, INSTAGRAM_HANDLE } from '../mock';

const Footer = ({ phone = WA_MAIN }) => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-brand">
          <img 
            src="https://customer-assets.emergentagent.com/job_legal-humana/artifacts/lct2abwc_sampellegrini_jaliff_logo_v3_institutional-removebg-preview.png" 
            alt="Sampellegrini & Jaliff"
            className="footer-logo-image"
          />
        </div>
        <div className="footer-info">
          <p className="footer-text">
            Derecho de Familia • Sucesiones • Civil • Laboral
          </p>
          <div className="footer-contact-info" data-testid="footer-contact-info">
            <p className="footer-contact-line">
              <MapPin className="footer-contact-icon" strokeWidth={1.8} />
              <span>{CONTACT_ADDRESS}</span>
            </p>
            <p className="footer-contact-line">
              <Clock className="footer-contact-icon" strokeWidth={1.8} />
              <span>{CONTACT_HOURS}</span>
            </p>
            <a href={getTelLink(phone)} onClick={trackPhoneClick} className="footer-contact-line footer-phone-link" data-testid="footer-phone-link">
              <Phone className="footer-contact-icon" strokeWidth={1.8} />
              <span>{toDisplay(phone)}</span>
            </a>
            <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" className="footer-contact-line footer-phone-link" data-testid="footer-instagram-link">
              <Instagram className="footer-contact-icon" strokeWidth={1.8} />
              <span>{INSTAGRAM_HANDLE}</span>
            </a>
          </div>
        </div>
        <div className="footer-bottom">
          <p className="footer-copyright">
            © {new Date().getFullYear()} Sampellegrini & Jaliff. Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
